import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import { authUserSelector } from '~redux/auth/selectors/authUser';
import { clearProduct } from '~redux/product/actions';
import { productModelSelector } from '~redux/product/selectors';
import { getProduct } from '~redux/product/thunk';
import { useThunkQueue } from '~view/hooks/thunk';
import { useTitle } from '~view/hooks/title';
import AuthPage from '~view/widgets/AuthPage';
import InventoryProvider from '~view/widgets/InventoryProvider';
import LoadingContainer from '~view/widgets/LoadingContainer';
import ProductPostDetails from '~view/widgets/ProductPostDetails';

type ProductDetailsProps = { sub?: string; admin?: boolean };

const ProductDetails: React.FC<ProductDetailsProps> = ({ admin }) => {
  const { id: productId } = useParams<{
    id: string;
  }>();
  const id = decodeURIComponent(productId);
  const dispatch = useDispatch();
  const { queue, isProcessing } = useThunkQueue('getProduct');
  const user = useSelector(authUserSelector);
  const product = useSelector(productModelSelector);

  useEffect(() => {
    if (!user) return;
    queue(getProduct(id, undefined, true));
    return () => {
      dispatch(clearProduct());
    };
  }, [user, id]);

  useTitle(`${product?.product_name} - Supplier`);

  return (
    <AuthPage>
      <InventoryProvider productIds={[id]}>
        <LoadingContainer isLoading={isProcessing}>
          <Container>
            {product && (
              <ProductPostDetails product={product} admin={admin} preview />
            )}
          </Container>
        </LoadingContainer>
      </InventoryProvider>
    </AuthPage>
  );
};

export default ProductDetails;
